import isEmpty from 'lodash/isEmpty';

export const getDifferenceInfoWindowPosition = () => {
  const map = document.getElementById('GMap');
  const mapCoordinates = map.getBoundingClientRect();
  const iWindow = document.querySelectorAll('.gm-style-iw')[0];
  const iWindowCoordinates = iWindow.getBoundingClientRect();

  const top = mapCoordinates.top - iWindowCoordinates.top;
  const left = mapCoordinates.left - iWindowCoordinates.left;

  const iWindowRight = iWindowCoordinates.left + iWindowCoordinates.width;
  const mapRight = mapCoordinates.left + mapCoordinates.width;
  const right = iWindowRight - mapRight;

  const result = {};

  if (top > 0) result.top = top;
  if (left > 0) result.left = left;
  if (right > 0) result.right = right;

  return isEmpty(result) ? null : result;
};
